import React, { useState } from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { useMediaQuery, useTheme, IconButton } from '@material-ui/core';

import CloseIcon from '/public/icons/close-dark.svg';
import useOnlyFansConnections from 'hooks/useOnlyFansConnections';
import {
  getDismissedOFDisconnectedAlert,
  setDismissedOFDisconnectedAlert,
} from 'utils/localStorage';

const ReconnectOnlyFansC4Alert = () => {
  const isAlertDismissed = getDismissedOFDisconnectedAlert();
  const [alertVisible, setAlertVisible] = useState(!isAlertDismissed);
  const { anyDisabledConnections } = useOnlyFansConnections();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const showDisconnectedAlert = anyDisabledConnections && alertVisible;

  if (!showDisconnectedAlert) return null;

  return (
    <motion.div
      style={{
        margin: isDesktop ? 40 : 15,
        marginTop: 20,
        background: 'rgba(255, 75, 75, 0.2)',
        borderRadius: 15,
        padding: 20,
      }}
      initial={{ x: -300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
    >
      <div style={{ borderRadius: 15 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 10,
          }}
        >
          <h2 style={{ color: '#ff4b4b' }}>OnlyFans account disconnected</h2>

          <IconButton
            onClick={() => {
              setDismissedOFDisconnectedAlert(true);
              setAlertVisible(false);
            }}
            style={{ padding: 5 }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <p style={{ color: '#323643' }}>
          We've lost connection with some of your connected accounts. This can happen if you
          recently changed your OnlyFans email or password. Please{' '}
          {
            <Link href="/of-connections" passHref>
              <strong className="color-main">reconnect</strong>
            </Link>
          }{' '}
          to continue using the benefits of the integration.
        </p>
      </div>
    </motion.div>
  );
};

export default ReconnectOnlyFansC4Alert;
